<ng-container [ngSwitch]="layout$ | async">
  <app-fresh-main-page *ngSwitchCase="layouts.Fresh"></app-fresh-main-page>
</ng-container>
